import request from '@/utils/request'

const prefix = '/django_rest/open-api-management'

export default {
  createExportOpenApiMetaDataTask (taskInfo) {
    return request.post(`${prefix}/meta-info/export/`, taskInfo)
  },
  getExportOpenApiMetaDataTask (params) {
    return request.get(`${prefix}/meta-info/export/`, { params })
  },
  getOpenApiAppList (params) {
    return request.get(`${prefix}/app/`, { params })
  },
  createOpenApiApp (appInfo) {
    return request.post(`${prefix}/app/`, appInfo)
  },
  updateOpenApiApp (appId, appInfo) {
    return request.put(`${prefix}/app/${appId}/`, appInfo)
  },
  getOpenApiList (params) {
    return request.get(`${prefix}/`, { params })
  },
  getOpenApiConfigList (params) {
    return request.get(`${prefix}/config-list/`, { params })
  },
  getOpenApiConfig (openApiId, params) {
    return request.get(`${prefix}/${openApiId}/config/`, { params })
  },
  getOpenApiConfigById (openApiId, configId) {
    return request.get(`${prefix}/${openApiId}/config/${configId}/`)
  },
  saveOpenApiConfig (openApiId, configInfo) {
    return request.post(`${prefix}/${openApiId}/config/`, configInfo)
  },
  updateOpenApiConfig (openApiId, configId, configInfo) {
    return request.post(`${prefix}/${openApiId}/config/${configId}/`, configInfo)
  },
  updateOpenApiConfigStatus (openApiId, configId, updateInfo) {
    return request.put(`${prefix}/${openApiId}/config/${configId}/`, updateInfo)
  }
}
